import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { CSSProperties } from "@material-ui/styles";
// import { DateTime } from "@saleor/components/Date";
import Money from "@saleor/components/Money";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import StatusLabel from "@saleor/components/StatusLabel";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TablePagination from "@saleor/components/TablePagination";
import {
  maybe,
  renderCollection,
  splitDateTime,
  transformOrderStatus,
  transformPaymentStatus
} from "@saleor/misc";
import { OrderListUrlSortField } from "@saleor/orders/urls";
import { ListProps, SortPage } from "@saleor/types";
import { getArrowDirection } from "@saleor/utils/sort";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { OrderList_orders_edges_node } from "../../types/OrderList";

const useStyles = makeStyles(
  theme => {
    const overflowing: CSSProperties = {
      overflow: "hidden",
      textOverflow: "ellipsis"
    };

    return {
      [theme.breakpoints.up("lg")]: {
        colCustomer: {
          width: 200,
          overflow: "hidden", // 超出的文本隐藏
          textOverflow: "ellipsis", // 溢出用省略号显示
          whiteSpace: "nowrap" // 溢出不换行
        },
        colDate: {
          width: 120
          // overflow: "hidden", // 超出的文本隐藏
          // textOverflow: "ellipsis", // 溢出用省略号显示
          // whiteSpace: "nowrap" // 溢出不换行
        },
        colFulfillment: {
          width: 150
        },
        colNumber: {
          width: 120
        },
        colCurrency: {
          width: 100,
          textAlign: "center"
        },
        colCampaign: {
          width: 300
        },
        colPayment: {
          width: 150
        },
        sendErp: {
          width: 120
          // textAlign: "center"
        },
        middleCode: {
          width: 130,
          overflow: "hidden", // 超出的文本隐藏
          textOverflow: "ellipsis", // 溢出用省略号显示
          whiteSpace: "nowrap", // 溢出不换行
          "&:hover": {}
        },
        colTotal: {}
      },
      // colCustomer: overflowing,
      colDate: {},
      colFulfillment: overflowing,
      colNumber: {},
      colPayment: overflowing,
      colCurrency: {},
      colCampaign: overflowing,
      colTotal: {
        textAlign: "right"
      },
      link: {
        cursor: "pointer"
      }
    };
  },
  { name: "OrderList" }
);

interface OrderListProps extends ListProps, SortPage<OrderListUrlSortField> {
  orders: OrderList_orders_edges_node[];
}

const numberOfColumns = 9;

export const OrderList: React.FC<OrderListProps> = props => {
  const {
    disabled,
    settings,
    orders,
    pageInfo,
    onPreviousPage,
    onNextPage,
    onUpdateListSettings,
    onRowClick,
    onSort,
    sort
  } = props;
  const classes = useStyles(props);

  const intl = useIntl();

  const orderList = orders
    ? orders.map(order => ({
        ...order,
        paymentStatus: transformPaymentStatus(order.paymentStatus, intl),
        status: transformOrderStatus(order.status, intl)
      }))
    : undefined;
  return (
    <ResponsiveTable>
      <TableHead>
        <TableCellHeader
          direction={
            sort.sort === OrderListUrlSortField.number
              ? getArrowDirection(sort.asc)
              : undefined
          }
          arrowPosition="right"
          onClick={() => onSort(OrderListUrlSortField.number)}
          className={classes.colNumber}
        >
          <FormattedMessage defaultMessage="No. of Order" />
        </TableCellHeader>
        <TableCellHeader
          direction={
            sort.sort === OrderListUrlSortField.date
              ? getArrowDirection(sort.asc)
              : undefined
          }
          onClick={() => onSort(OrderListUrlSortField.date)}
          className={classes.colDate}
        >
          <FormattedMessage
            defaultMessage="Date"
            description="date when order was placed"
          />
        </TableCellHeader>
        <TableCellHeader
          direction={
            sort.sort === OrderListUrlSortField.customer
              ? getArrowDirection(sort.asc)
              : undefined
          }
          onClick={() => onSort(OrderListUrlSortField.customer)}
          className={classes.colCustomer}
        >
          <FormattedMessage
            defaultMessage="Customer"
            description="e-mail or full name"
          />
        </TableCellHeader>
        <TableCellHeader className={classes.sendErp}>
          <FormattedMessage defaultMessage="NewUser" description="NewUser" />
        </TableCellHeader>
        <TableCellHeader className={classes.colCampaign}>
          <FormattedMessage
            defaultMessage="Campaign & Refer Code"
            description="Campaign"
          />
        </TableCellHeader>
        {/* <TableCellHeader className={classes.middleCode}>
          <FormattedMessage
            defaultMessage="Refer Code"
            description="Referral"
          />
        </TableCellHeader> */}
        <TableCellHeader
        // direction={
        //   sort.sort === OrderListUrlSortField.payment
        //     ? getArrowDirection(sort.asc)
        //     : undefined
        // }
        // onClick={() => onSort(OrderListUrlSortField.payment)}
        // className={classes.sendErp}
        >
          <FormattedMessage
            defaultMessage="SendErp"
            description="payment status"
          />
        </TableCellHeader>

        <TableCellHeader
          direction={
            sort.sort === OrderListUrlSortField.payment
              ? getArrowDirection(sort.asc)
              : undefined
          }
          onClick={() => onSort(OrderListUrlSortField.payment)}
          className={classes.colPayment}
        >
          <FormattedMessage
            defaultMessage="Payment"
            description="payment status"
          />
        </TableCellHeader>

        <TableCellHeader
          direction={
            sort.sort === OrderListUrlSortField.fulfillment
              ? getArrowDirection(sort.asc)
              : undefined
          }
          onClick={() => onSort(OrderListUrlSortField.fulfillment)}
          className={classes.colFulfillment}
        >
          <FormattedMessage
            defaultMessage="Fulfillment"
            description="fulfillment status"
          />
        </TableCellHeader>

        <TableCellHeader className={classes.colCurrency}>
          <FormattedMessage
            defaultMessage="Currency"
            description="order currency"
          />
        </TableCellHeader>
        <TableCellHeader
          direction={
            sort.sort === OrderListUrlSortField.total
              ? getArrowDirection(sort.asc)
              : undefined
          }
          textAlign="right"
          onClick={() => onSort(OrderListUrlSortField.total)}
          className={classes.colTotal}
        >
          <FormattedMessage
            defaultMessage="Total"
            description="total order price"
          />
        </TableCellHeader>
      </TableHead>
      <TableFooter>
        <TableRow>
          <TablePagination
            colSpan={numberOfColumns}
            settings={settings}
            hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
            onNextPage={onNextPage}
            onUpdateListSettings={onUpdateListSettings}
            hasPreviousPage={
              pageInfo && !disabled ? pageInfo.hasPreviousPage : false
            }
            onPreviousPage={onPreviousPage}
          />
        </TableRow>
      </TableFooter>
      <TableBody>
        {renderCollection(
          orderList,
          order => (
            // eslint-disable-next-line no-console
            <TableRow
              hover={!!order}
              className={!!order ? classes.link : undefined}
              onClick={order ? onRowClick(order.id) : undefined}
              key={order ? order.id : "skeleton"}
            >
              <TableCell className={classes.colNumber}>
                {maybe(() => order.number) ? "#" + order.number : <Skeleton />}
              </TableCell>
              <TableCell className={classes.colDate}>
                {/* {maybe(() => order.created) ? (
                  <DateTime date={order.created} />
                ) : (
                  <Skeleton />
                )} */}

                {order && order.created ? (
                  <p
                    className={classes.colDate}
                    title={
                      splitDateTime(maybe(() => order.created, "")).date +
                      " " +
                      splitDateTime(maybe(() => order.created, "")).time
                    }
                  >
                    {splitDateTime(maybe(() => order.created, "")).date +
                      " " +
                      splitDateTime(maybe(() => order.created, "")).time}
                  </p>
                ) : (
                  <Skeleton />
                )}
              </TableCell>
              <TableCell className={classes.colCustomer}>
                {maybe(() => order.userEmail) !== undefined ? (
                  <p
                    title={order.userEmail}
                    className={classes.colCustomer}
                    style={{ width: "100%" }}
                  >
                    {order.userEmail}
                  </p>
                ) : maybe(() => order.billingAddress) ? (
                  <>
                    {order.billingAddress.firstName}
                    &nbsp;
                    {order.billingAddress.lastName}
                  </>
                ) : (
                  <Skeleton />
                )}
              </TableCell>
              <TableCell className={classes.sendErp}>
                {order?.isNewCustomer !== null &&
                order?.isNewCustomer !== undefined ? (
                  <StatusLabel
                    status={order?.isNewCustomer ? "success" : "error"}
                    label={` ${order?.isNewCustomer ? "new" : "returning"}`}
                  />
                ) : (
                  <Skeleton />
                )}
              </TableCell>

              <TableCell className={classes.colCampaign}>
                {maybe(() => order) ? (
                  <p
                    title={order.campaign}
                    className={classes.colCampaign}
                    style={{ width: "100%" }}
                  >
                    {order.campaign ? (
                      <>
                        <strong style={{ color: "#21125E" }}>CMPN: </strong>
                        <span>{order.campaign}</span>
                        <br />
                      </>
                    ) : (
                      ""
                    )}

                    {order.recommendCode ? (
                      <>
                        <strong style={{ color: "#21125E" }}>Ref: </strong>
                        <span>{order.recommendCode}</span>
                        <br />
                      </>
                    ) : (
                      ""
                    )}

                    {order.refId ? (
                      <>
                        <strong style={{ color: "#21125E" }}>Ref: </strong>
                        <span>{order.refId}</span>
                        <br />
                      </>
                    ) : (
                      ""
                    )}

                    {order.referralCode ? (
                      <>
                        <strong style={{ color: "#21125E" }}>Aff: </strong>
                        <span>{order.referralCode}</span>
                        <br />
                      </>
                    ) : (
                      ""
                    )}

                    {order.tiktokAuthorId ? (
                      <>
                        <strong style={{ color: "#21125E" }}> TikTok</strong>
                        <br />
                        <strong style={{ color: "#21125E" }}>
                          {" "}
                          author_id:{" "}
                        </strong>
                        <span>{order.tiktokAuthorId}</span>
                        <br />
                      </>
                    ) : (
                      ""
                    )}

                    {order.tiktokSourceContentId ? (
                      <>
                        <strong style={{ color: "#21125E" }}>
                          source_content_id:{" "}
                        </strong>
                        <span>{order.tiktokSourceContentId}</span>
                        <br />
                      </>
                    ) : (
                      ""
                    )}

                    {/* {order.recommendCode?"Ref:"+order.recommendCode:""}<br/>
                      {order.referralCode?"Aff:"+order.referralCode:""}<br/> */}
                  </p>
                ) : (
                  <Skeleton />
                )}
              </TableCell>
              {/* <TableCell className={classes.middleCode}>
                  {order ? (
                    <p
                      title={
                        order.recommendCode !== null &&
                        order.recommendCode !== ""
                          ? "Ref:" + order.recommendCode
                          : order.referralCode !== null &&
                            order.referralCode !== ""
                          ? "Aff:" + order.referralCode
                          : ""
                      }
                      className={classes.middleCode}
                      style={{ width: "100%" }}
                    >
                      {order.recommendCode !== null &&
                      order.recommendCode !== ""
                        ? "Ref:" + order.recommendCode
                        : order.referralCode !== null &&
                          order.referralCode !== ""
                        ? "Aff:" + order.referralCode
                        : ""}
                    </p>
                  ) : (
                    <Skeleton />
                  )}
                </TableCell> */}
              <TableCell className={classes.sendErp}>
                {order?.sendErp !== null && order?.sendErp !== undefined ? (
                  <StatusLabel
                    status={order?.sendErp ? "success" : "error"}
                    label={` ${order?.sendErp ? "Yes" : "No"}`}
                  />
                ) : (
                  <Skeleton />
                )}
              </TableCell>

              <TableCell className={classes.colPayment}>
                {maybe(() => order.paymentStatus.status) !== undefined ? (
                  order.paymentStatus.status === null ? null : (
                    <StatusLabel
                      status={order.paymentStatus.status}
                      label={order.paymentStatus.localized}
                    />
                  )
                ) : (
                  <Skeleton />
                )}
              </TableCell>

              <TableCell className={classes.colFulfillment}>
                {maybe(() => order.status) ? (
                  <StatusLabel
                    status={order.status.status}
                    label={order.status.localized}
                  />
                ) : (
                  <Skeleton />
                )}
              </TableCell>
              <TableCell className={classes.colCurrency}>
                {maybe(() => order.currency) ? order.currency : <Skeleton />}
              </TableCell>
              <TableCell className={classes.colTotal}>
                {maybe(() => order.total.gross) ? (
                  <Money money={order.total.gross} />
                ) : (
                  <Skeleton />
                )}
              </TableCell>
            </TableRow>
          ),
          () => (
            <TableRow>
              <TableCell colSpan={numberOfColumns}>
                <FormattedMessage defaultMessage="No orders found" />
              </TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </ResponsiveTable>
  );
};
OrderList.displayName = "OrderList";
export default OrderList;
